import DesLibraryPublishViewModel from 'viewmodel/DesLibraryPublishViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesLibraryPublish extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryPublishViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get libraryId() {
        return this.getAttribute('libraryid') || this.getAttribute('library-id');
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'libraryid', 'library-id'];
    }
}

if (!window.customElements.get('des-library-publish')) {
    window.customElements.define('des-library-publish', DesLibraryPublish);
}
